import {StatusDetailRes, WorkflowStatusMinRes} from "../status.contract";
import {NoteDetailRes} from "../note/note.contract";
import {WorkflowDetailRes} from "../workflow.contract";
import {TrackerType} from '../../../../enums';
import {Type} from 'class-transformer';
import {
    ColumnType,
    DetailGridIgnore,
    DetailGridProperties,
    DisplayName,
    FilterType,
    RequestOverride,
    TableColumn,
    TableDisplayFn,
    TableIgnore, TableIndex,
    yascColumnFilterType,
    yascFilterByFn,
    yascFilterConfig,
    yascLevelOfDetail,
    YascOptionItem,
    yascRequired
} from '@yasc/yasc-material-components';
import {ProjectSummaryGroupingRes} from '../project.contract';

export class TrackerDetailRes {
    // TODO: hide per default -> maybe map to table No.?
    @DisplayName('general_backendId')
    @TableIndex(0)
    @DetailGridIgnore()
    id!: number;

    @DisplayName('general_name')
    @DetailGridProperties({ row: 1, width:1 })
    @yascRequired()
    name!: string;

    @TableIgnore(true)
    @DisplayName('general_type')
    type!: TrackerType;

    @TableIgnore(true)
    @DetailGridIgnore()
    isActive: boolean = true;

    @DisplayName('general_currentStatus')
    @TableDisplayFn((value?: StatusDetailRes) => value?.name ?? '')
    @TableColumn(ColumnType.Select)
    @DetailGridProperties({ row: 4, width: 2 })
    @RequestOverride('currentStatusId')
    @yascLevelOfDetail(2)
    @Type(() => StatusDetailRes)
    @yascColumnFilterType(FilterType.select)
    @yascFilterByFn((value: TrackerDetailRes) => value.currentWorkflowStatus.id)
    @yascFilterConfig({
        getGroup: (value: ProjectSummaryGroupingRes) => value?.availableWorkflows ?? [],
        mapToFilter: (value: WorkflowStatusMinRes) => new YascOptionItem(value.name, value.id)
    })
    currentWorkflowStatus!: StatusDetailRes;

    workflowId!: number;

    @TableIgnore(true)
    @Type(() => StatusDetailRes)
    @DetailGridIgnore()
    statusHistory: StatusDetailRes[] = [];

    @TableIgnore(true)
    @DetailGridIgnore()
    @Type(() => NoteDetailRes)
    notes: NoteDetailRes[] = [];


    @TableIgnore(true)
    @DetailGridIgnore()
    setStatusOptions!:() => YascOptionItem<number>
}


export abstract class MinTrackerRes {
    id!: number;

    @Type(() => WorkflowDetailRes)
    workflow!: WorkflowDetailRes;

    @Type(() => StatusDetailRes)
    currentStatus!: StatusDetailRes;
}

export class TrackerCreateReq {
    workflowId!: number;
    name!:string;
    currentStatusId!: number;
}

export class TrackerAdvanceReq {
    trackerId!: number
    statusId!: number
}

export class TrackerWorkflowRes{
    id!:number;
    currentWorkflowStatus!: StatusDetailRes;
    name!:string;
}